export enum ReferralsPathsEnum {
  ROOT = "referrals",
}

export enum ReferralsRoutesEnum {
  ROOT = "/menu/referrals",
}
